export const INTEGRATION_TYPE_OPTIONS = [
  { value: 'API', disabled: false },
  { value: 'RPA', disabled: true },
] as const;

export const PROCESS_TYPE_OPTIONS = [
  { value: 'COPARTICIPATION', disabled: false },
  { value: 'CARRIER_CADASTRAL_MOVEMENT', disabled: true },
  { value: 'CLIENT_CADASTRAL_MOVEMENT', disabled: true },
  { value: 'PAYROLL', disabled: true },
] as const;

export const REQUEST_STATUS_OPTIONS = [
  'RECEIVED',
  'PROCESSING',
  'COMPLETED',
  'COMPLETED_WITH_ERRORS',
] as const;

export type RequestStatusTone = 'success' | 'warning' | 'error' | 'info';

export const REQUEST_STATUS_VISUAL_MAP: Record<string, { tone: RequestStatusTone }> = {
  RECEIVED: { tone: 'info' },
  PROCESSING: { tone: 'warning' },
  COMPLETED: { tone: 'success' },
  COMPLETED_WITH_ERRORS: { tone: 'error' },
  PROCESSED: { tone: 'success' },
  PARTIALLY_PROCESSED: { tone: 'error' },
  ERROR: { tone: 'error' },
};

export const INTEGRATION_MONITORING_API_BASE = '/statement';

export const MONITORING_ENDPOINTS = {
  indicators: '/v1/internal/monitoring/indicators',
  list: '/v1/internal/monitoring/batches',
};
